import { RoomApiData } from "./room-data";

interface FloorData {
  id: string;
  name: string;
}

export interface FloorApiData {
  id: string;
  name: string;
  rooms: RoomApiData[];
}

export default FloorData;

export const mapFloorApiDataToFloorData = (apiData: FloorApiData[]) => {
  const floorsData: FloorData[] = [];

  apiData.forEach((floor) => {
    floorsData.push({ ...floor });
  });

  return floorsData;
};
